import { Form, Select, TimePicker } from 'antd';
import timezones from '@/pages/OrgSettings/timezone';
import ContentPanel from '../components/ContentPanel';
import Buttons from '../components/Buttons';
import { TITLE, DESC } from './const';

export default function ProcessingTime() {
  return (
    <ContentPanel title={TITLE.first} desc={DESC.first} step={1} total={2}>

      <Form.Item label="Time zone" name="timeZone">
        <Select options={timezones} style={{ width: '100%' }} />
      </Form.Item>
      <Form.Item label="Time" name="time">
        <TimePicker format="h:mm A" hourStep={1} minuteStep={60} needConfirm showNow={false} style={{ width: '100%' }} use12Hours />
      </Form.Item>

      <Form.Item
        shouldUpdate
      >
        {({ getFieldValue }) => {
          const isDisabled = !getFieldValue('timeZone') || !getFieldValue('time');
          return (
            <Buttons
              backUrl=""
              nextUrl="../days-off"
              isDisabled={isDisabled}
            />
          );
        }}
      </Form.Item>
    </ContentPanel>

  );
}
